export interface FooterData {
  questionsContact: string;
  email: string;
  cellPhone: string;
  workPhone: string;
  companyNameShort: string;
  companyName: string;
}

export const footerData: FooterData = {
  questionsContact: 'Questions? Contact Revolution Mortgage',
  email: 'transitionloannot@revolutionmortgage.com',
  cellPhone: '+16149180055',
  workPhone: '+16149180055',
  companyNameShort: 'Revolution Mortgage 1686046',
  companyName: 'Revolution Mortgage NMLS #1686046',
};
